<!--
 * @Description: 聚丙烯纤维模板
 * @Autor: yjx
 * @Date: 2021-11-17 16:31:54
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-12-29 17:06:03
-->
<template>
  <div id="template10" class="template_table_parent">
    <table class="template_table" border="1" cellpadding="0" cellspacing="0" @change="getChanges">
      <tr>
        <td colspan="7"></td>
        <td>检测编号：</td>
        <td :class="{ bg5: !isViewResult }">{{ defaultData.code }}</td>
      </tr>
      <tr>
        <td>委托单位</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_01 }}</td>
        <td>品 种</td>
        <td :class="{ bg5: !isViewResult }">{{ defaultData.cell_02 }}</td>
        <td>出厂编号</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_03.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>取样日期</td>
        <td :class="{ bg5: !isViewResult }">{{ defaultData.cell_04 }}</td>
      </tr>
      <tr>
        <td>检测单位</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_05 }}</td>
        <td>等 级</td>
        <td :class="{ bg5: !isViewResult }">{{ defaultData.cell_06 }}</td>
        <td>车牌号</td>
        <td :class="{ bg5: !isViewResult }">{{ defaultData.cell_07 }}</td>
        <td>试验日期</td>
        <td :class="{ bg3: !isViewResult }" class="select_date">
          <el-date-picker v-model="formData.cell_08.resultValue" type="datetime" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择"> </el-date-picker>
        </td>
      </tr>
      <tr>
        <td>生产厂家</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_09 }}</td>
        <td>品 牌</td>
        <td :class="{ bg5: !isViewResult }">{{ defaultData.cell_10 }}</td>
        <td>环境温度</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_11.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>代表批量</td>
        <td :class="{ bg5: !isViewResult }">{{ defaultData.cell_12 }}</td>
      </tr>
      <tr>
        <td>送货单位</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_13 }}</td>
        <td>样品来源</td>
        <td :class="{ bg5: !isViewResult }">{{ defaultData.cell_14 }}</td>
        <td>环境湿度</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_15.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>检测依据</td>
        <td :class="{ bg4: !isViewResult }">
          <el-input v-model="formData.cell_16.resultValue" placeholder="请输入" disabled :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td>材质证明</td>
        <td :class="{ bg5: !isViewResult }" colspan="8">
          <el-select v-model="formData.cell_17.resultValue" value-key="id">
            <el-option v-for="item in formData.cell_17.options" :key="item.id" :label="item.label" :value="item"></el-option>
          </el-select>
        </td>
      </tr>
      <tr>
        <td>含水量</td>
        <td>样品重（g）</td>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_18.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>烘干后重（g）</td>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_19.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>含水量（%）</td>
        <td :class="formData.cell_20.clsObj">
          {{ formData.cell_20.resultValue }}
          <el-tooltip v-if="formData.cell_20.exceed" class="item" effect="dark" placement="right">
            <div slot="content">{{ formData.cell_20.exceed }}</div>
            <i class="el-icon-s-flag"></i>
          </el-tooltip>
        </td>
      </tr>
      <tr>
        <td rowspan="3">品种一致性</td>
        <td colspan="2">易燃</td>
        <td :class="formData.cell_21.clsObj" colspan="6">
          <el-select v-model="formData.cell_21.resultValue" filterable value-key="value" placeholder="请选择">
            <el-option :value="0" label="易燃" />
            <el-option :value="1" label="不易燃" />
          </el-select>
        </td>
      </tr>
      <tr>
        <td colspan="2">可拉丝</td>
        <td :class="formData.cell_22.clsObj" colspan="6">
          <el-select v-model="formData.cell_22.resultValue" filterable value-key="value" placeholder="请选择">
            <el-option :value="0" label="可拉丝" />
            <el-option :value="1" label="不可拉丝" />
          </el-select>
        </td>
      </tr>
      <tr>
        <td colspan="2">水中不沉底</td>
        <td :class="formData.cell_23.clsObj" colspan="6">
          <el-select v-model="formData.cell_23.resultValue" filterable value-key="value" placeholder="请选择">
            <el-option :value="0" label="浮出水面（合格）" />
            <el-option :value="1" label="沉入水底（不合格）" />
          </el-select>
        </td>
      </tr>
      <tr>
        <td>分散性</td>
        <td colspan="2">水中易分散</td>
        <td :class="formData.cell_24.clsObj" colspan="6">
          <el-select v-model="formData.cell_24.resultValue" filterable value-key="value" placeholder="请选择">
            <el-option :value="0" label="水中均匀分散（合格）" />
            <el-option :value="1" label="水中不易分散（不合格）" />
          </el-select>
        </td>
      </tr>
      <tr>
        <td>溶解性</td>
        <td colspan="2">水中不溶解</td>
        <td :class="formData.cell_25.clsObj" colspan="6">
          <el-select v-model="formData.cell_25.resultValue" filterable value-key="value" placeholder="请选择">
            <el-option :value="0" label="水中不溶解" />
            <el-option :value="1" label="水中易溶解" />
          </el-select>
        </td>
      </tr>
      <tr>
        <td rowspan="2">备 注</td>
        <td rowspan="2" colspan="8">
          <el-input v-model="formData.cell_26.resultValue" type="textarea" :rows="2" :readonly="isViewResult" />
        </td>
      </tr>
      <tr></tr>
      <tr>
        <td></td>
        <td>审核：</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.reviewer }}</td>
        <td></td>
        <td>试验：</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">
          {{ user.inspector.label }}
        </td>
        <td></td>
      </tr>
    </table>

    <SetPopupDialog :visible.sync="popupVisible" :config="popupConfig" @updated="updated" @formChange="changeFun" />
  </div>
</template>
<script>
import SetPopupDialog from "../SetPopupDialog";
// import { getUsetListByPermission } from "@/api/index.js"

const dataArr = {
  cell_03: { resultValue: "", key: "ccbh", title: "出场编号", category: 3, type: 3, code: "cell_03" },
  cell_08: { resultValue: "", key: "syrq", title: "试验日期", category: 3, type: 3, code: "cell_08" },
  cell_11: { resultValue: "", key: "hjwd", title: "环境温度", category: 3, type: 3, code: "cell_11" },
  cell_15: { resultValue: "", key: "hjsd", title: "环境湿度", category: 3, type: 3, code: "cell_15" },
  cell_16: { resultValue: "JGJ52 - 2006", key: "jcyj", title: "检测依据", category: 6, type: 2, code: "cell_16", default: "JGJ52 - 2006" },
  cell_17: {
    resultValue: "",
    title: "材质证明",
    category: 7,
    type: 1,
    options: [
      { id: 0, label: "齐全且一致" },
      { id: 1, label: "不齐全或不一致" },
    ],
    clsObj: { bg5: true },
  },
  cell_18: { resultValue: "", key: "ypz", title: "样品重", category: 6, type: 3, code: "cell_18" },
  cell_19: { resultValue: "", key: "hghz", title: "烘干后重", category: 6, type: 3, code: "cell_19" },
  cell_21: { resultValue: "", key: "yr", title: "易燃", category: 1, type: 3, code: "cell_21", clsObj: { bg1: true } },
  cell_22: { resultValue: "", key: "kls", title: "可拉丝", category: 1, type: 3, code: "cell_22", clsObj: { bg1: true } },
  cell_23: { resultValue: "", key: "szbcd", title: "水中不沉底", category: 1, type: 3, code: "cell_23", clsObj: { bg1: true } },
  cell_24: { resultValue: "", key: "szyfs", title: "水中易分散", category: 1, type: 3, code: "cell_24", clsObj: { bg1: true } },
  cell_25: { resultValue: "", key: "szbrj", title: "水中不溶解", category: 1, type: 3, code: "cell_25", clsObj: { bg1: true } },
  cell_26: { resultValue: "", key: "bz", title: "备注", category: 6, type: 3, code: "cell_26" },

  // 以下为计算属性
  cell_20: { resultValue: "", key: "hsl", title: "含水量", category: 1, type: 3, code: "cell_20", clsObj: { bg1: true } },
};

export default {
  components: {
    SetPopupDialog,
  },
  props: {
    defaultData: {
      // 默认基本数据
      type: Object,
      default: () => {},
    },
    saveData: {
      // 保存的数据
      type: Object,
      default: () => {},
    },
    user: {
      // 试验人
      type: Object,
      default: () => {
        return {
          approver: {
            label: "",
          },
          inspector: {
            label: "",
          },
        };
      },
    },
    buttonType: {
      // 点击按钮的类型 save保存 submit提交（会校验必填项）
      type: String,
      default: "",
    },
    isViewResult: {
      // 查看结果还是录入数据
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: null,
      popupVisible: false,
      popupConfig: null,
      options: [],
      curKey: "xx",
    };
  },
  created() {
    if (Object.keys(this.saveData).length === 0) {
      this.formData = JSON.parse(JSON.stringify(dataArr));
    } else {
      let form = JSON.parse(JSON.stringify(this.saveData));
      for (let key in dataArr) {
        let item = form[key];
        if (item) {
          if (this.isViewResult) {
            // 查看，设置查看效果
            if (item.clsObj) {
              for (let i in item.clsObj) {
                item.clsObj[i] = false;
              }
              if (item.isQualified === 0) {
                item.clsObj["red-bg"] = true;
              } else if (item.type === 2 && item.isOverAdjacentFluctuation === 1) {
                item.clsObj["yellow-bg"] = true;
              }
            }
          }
        }else {
          item = dataArr[key];
          if (this.isViewResult) {
            // 查看，设置查看效果
            if (item.clsObj) {
              for (let i in item.clsObj) {
                item.clsObj[i] = false;
              }
              if (item.isQualified === 0) {
                item.clsObj["red-bg"] = true;
              } else if (item.type === 2 && item.isOverAdjacentFluctuation === 1) {
                item.clsObj["yellow-bg"] = true;
              }
            }
          }
        }
      }
      this.formData = form;
    }
    for (const key in this.formData) {
      let item = this.formData[key];
      if (item.options && item.resultValue && typeof item.resultValue === "string") {
        console.log(item);
        item.resultValue = JSON.parse(item.resultValue);
      }
    }
  },
  mounted() {
    if (this.defaultData) {
      // 处理快检数据
      for (const key in this.defaultData) {
        if (/^cell/.test(key)) {
          let res = this.defaultData[key];
          if (res && this.defaultData.content && this.defaultData.content[key] && this.defaultData.content[key].type === 1) {
            res = JSON.parse(res);
          }
          if (!this.formData[key]) {
            let data = dataArr[key];
            if (!data) {
              data = { resultValue: "", category: 6, type: 1 };
            }
            this.$set(this.formData, key, data);
          }
          if (!this.formData[key].resultValue) {
            this.formData[key].resultValue = res;
          }
        }
      }
    }
    const content = this.defaultData.content;
    if (content) {
      for (const key in content) {
        if (/^cell/.test(key)) {
          if (!this.formData[key]) {
            this.$set(this.formData, key, dataArr[key]);
          }
        }
      }
    }

    // console.log(this.defaultData, this.saveData, dataArr.length)
    console.log(this.formData, this.formData.cell_134);
  },
  methods: {
    getChanges() {
      // 有输入就核算
      let val = "";
      // 含水量
      if (this.hasValues([18, 19])) {
        val = Math.round(((this.getFieldVal(18) - this.getFieldVal(19)) / this.getFieldVal(19)) * 100);
      }
      console.log("val", val);
      this.setFieldVal(20, val);
    },
    hasValues(indexArr, form) {
      if (!form) {
        form = this.formData;
      }
      let res = true;
      for (let i = 0, len = indexArr.length, key; i < len; i++) {
        key = "cell_" + indexArr[i];
        if (!form[key]) {
          console.log(key, "没有在formData中");
          res = false;
          break;
        } else if (form[key].resultValue === undefined || form[key].resultValue.length === 0) {
          console.log(key, "没有输入");
          res = false;
          break;
        }
      }

      return res;
    },
    // 计算堆积密度值
    calcTime(x, y, z) {
      let res = "";
      if (this.hasValues([x, y])) {
        let v1 = this.getFieldVal(x, true);
        let v2 = this.getFieldVal(y, true);
        res = (new Date(v2).getTime() - new Date(v1).getTime()) / 1000 / 60;
        res = Math.round(res);
      }
      this.setFieldVal(z, res);
    },
    // 计算平均值
    calcAverage(arr, z) {
      let res = "";
      if (this.hasValues(arr)) {
        let sum = 0;
        for (let key in arr) {
          sum = sum + this.getFieldVal(arr[key]);
        }
        res = (sum / arr.length).toFixed(2);
      }
      this.setFieldVal(z, res);
    },

    getFieldVal(x, isText, form) {
      if (!form) {
        form = this.formData;
      }
      if (isText) {
        return form["cell_" + x].resultValue;
      }
      return form["cell_" + x].resultValue * 1;
    },
    setFieldVal(x, val) {
      this.formData["cell_" + x].resultValue = val;
    },
    setData(curKey) {
      this.curKey = curKey;
      let config = {
        form: {},
      };
      for (let key in this.formData) {
        if (key.indexOf(curKey) >= 0) {
          config.form[key] = this.formData[key];
        }
      }
      this.popupConfig = config;
      this.popupVisible = true;
    },
    changeFun(form) {
      console.log(form);
      let res = "";
      switch (this.curKey) {
        case "cell_32_":
          if (this.hasValues(form, ["32_p01", "32_p02", "32_p03"])) {
            res = (((this.getFieldVal("32_p03", false, form) - this.getFieldVal("32_p01", false, form)) / this.getFieldVal("32_p02", false, form)) * 100).toFixed(2);
          }
          this.setFieldVal("32_p04", res);
          this.setFieldVal(32, res);
          break;
        case "cell_33_":
          if (this.hasValues(form, ["33_p01", "33_p02", "33_p03"])) {
            res = (((this.getFieldVal("33_p01", false, form) + this.getFieldVal("33_p02", false, form) - this.getFieldVal("33_p03", false, form)) / this.getFieldVal("33_p02", false, form)) * 100).toFixed(2);
          }
          this.setFieldVal("33_p04", res);
          this.setFieldVal(33, res);
          break;
        default:
          break;
      }
    },
    updated(data) {
      const { form } = data;
      for (let key in form) {
        console.log(key);
        this.formData[key] = form[key];
      }
    },
    // 外部获取数据
    getData() {
      let form = JSON.parse(JSON.stringify(this.formData));
      // form.cell_134.resultValue = JSON.stringify(form.cell_134.resultValue)
      // for (const key in form) {
      //   if (typeof form[key].resultValue === "object") {
      //     form[key].resultValue = JSON.stringify(form[key].resultValue);
      //   }
      // }
      return form;
    },
  },
};
</script>
<style lang="scss">
#template1 {
  width: 1200px;
}
</style>
